import { render } from "./customer-details-modal.vue?vue&type=template&id=334a80b4"
import script from "./customer-details-modal.vue?vue&type=script&lang=js"
export * from "./customer-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__